import React, { useEffect, useState } from "react";
import { questionAnswersType } from "./hooks/types";

export const PollTextArea = ({
  updateOther,
  residentPollQuestionId,
  setIsSubmitDisabled,
  isExpired,
  userAnswers
}: {
  updateOther: (questionId: number, other: string) => void;
  residentPollQuestionId: number;
  setIsSubmitDisabled: (item: boolean) => void;
  isExpired?: boolean;
  userAnswers: questionAnswersType[];
}) => {
  const [other, setOther] = useState<string>("");

  useEffect(() => {
    const selectedAnswer =
      userAnswers?.find(
        (answer) => answer.residentPollQuestionId == residentPollQuestionId
      )?.other || "";
    setOther(selectedAnswer);
  }, [userAnswers, residentPollQuestionId]);

  useEffect(() => {
    if (other.length > 0) {
      setIsSubmitDisabled(false);
    } else {
      setIsSubmitDisabled(true);
    }
  }, [other]);
  return (
    <div>
      <textarea
        rows={10}
        name="description"
        placeholder="Enter your answer"
        id="description"
        className="block w-full border-gray-300 rounded-md shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
        value={other ?? ""}
        onChange={(e: any) => {
          setOther(e.target.value);
          updateOther(residentPollQuestionId, e.target.value);
        }}
        maxLength={1000}
        disabled={isExpired}
      />
      <p className="text-sm text-gray-500 mt-2">
        {1000 - (other?.length ?? 0)} characters remaining
      </p>
    </div>
  );
};
